import { render, staticRenderFns } from "./WxPay.vue?vue&type=template&id=d202fc3c&scoped=true"
import script from "./WxPay.vue?vue&type=script&lang=js"
export * from "./WxPay.vue?vue&type=script&lang=js"
import style0 from "./WxPay.vue?vue&type=style&index=0&id=d202fc3c&prod&lang=scss"
import style1 from "./WxPay.vue?vue&type=style&index=1&id=d202fc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d202fc3c",
  null
  
)

export default component.exports